import { render } from "./Teeth.vue?vue&type=template&id=2f9776b6"
import script from "./Teeth.vue?vue&type=script&lang=js"
export * from "./Teeth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__